import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { sharpRegular, sharpSolid } from './icon-defs';

// Icon name -> definition lookup tables.
// FA's types say aliases are string[], but actual data includes numeric Unicode codepoints.
// The cast is safe — FontAwesomeIcon handles both at runtime.
const regularIcons = {
  'angle-down': sharpRegular.faAngleDown,
  'angle-left': sharpRegular.faAngleLeft,
  'angle-right': sharpRegular.faAngleRight,
  'angles-left': sharpRegular.faAnglesLeft,
  'angles-right': sharpRegular.faAnglesRight,
  'arrow-down': sharpRegular.faArrowDown,
  'arrow-right': sharpRegular.faArrowRight,
  'arrow-rotate-right': sharpRegular.faArrowRotateRight,
  'arrow-up': sharpRegular.faArrowUp,
  book: sharpRegular.faBook,
  'book-bookmark': sharpRegular.faBookBookmark,
  'book-open': sharpRegular.faBookOpen,
  building: sharpRegular.faBuilding,
  check: sharpRegular.faCheck,
  'chevron-down': sharpRegular.faChevronDown,
  'chevron-right': sharpRegular.faChevronRight,
  'chevron-up': sharpRegular.faChevronUp,
  circle: sharpRegular.faCircle,
  'circle-check': sharpRegular.faCircleCheck,
  'circle-exclamation': sharpRegular.faCircleExclamation,
  'circle-half-stroke': sharpRegular.faCircleHalfStroke,
  'circle-plus': sharpRegular.faCirclePlus,
  'circle-xmark': sharpRegular.faCircleXmark,
  clock: sharpRegular.faClock,
  'clock-rotate-left': sharpRegular.faClockRotateLeft,
  code: sharpRegular.faCode,
  'code-branch': sharpRegular.faCodeBranch,
  'code-compare': sharpRegular.faCodeCompare,
  copy: sharpRegular.faCopy,
  download: sharpRegular.faDownload,
  ellipsis: sharpRegular.faEllipsis,
  file: sharpRegular.faFile,
  'file-code': sharpRegular.faFileCode,
  'file-lines': sharpRegular.faFileLines,
  folder: sharpRegular.faFolder,
  'folder-open': sharpRegular.faFolderOpen,
  gear: sharpRegular.faGear,
  inbox: sharpRegular.faInbox,
  key: sharpRegular.faKey,
  link: sharpRegular.faLink,
  minus: sharpRegular.faMinus,
  moon: sharpRegular.faMoon,
  pen: sharpRegular.faPen,
  plus: sharpRegular.faPlus,
  'right-from-bracket': sharpRegular.faRightFromBracket,
  search: sharpRegular.faSearch,
  sidebar: sharpRegular.faSidebar,
  sliders: sharpRegular.faSliders,
  sort: sharpRegular.faSort,
  spinner: sharpRegular.faSpinner,
  'sun-bright': sharpRegular.faSunBright,
  trash: sharpRegular.faTrash,
  'triangle-exclamation': sharpRegular.faTriangleExclamation,
  users: sharpRegular.faUsers,
  xmark: sharpRegular.faXmark,
} as unknown as Record<string, IconDefinition>;

const solidIcons = {
  'arrow-rotate-right': sharpSolid.faArrowRotateRight,
  building: sharpSolid.faBuilding,
  check: sharpSolid.faCheck,
  circle: sharpSolid.faCircle,
  'circle-check': sharpSolid.faCircleCheck,
  'circle-exclamation': sharpSolid.faCircleExclamation,
  'circle-xmark': sharpSolid.faCircleXmark,
  minus: sharpSolid.faMinus,
  spinner: sharpSolid.faSpinner,
} as unknown as Record<string, IconDefinition>;

export function getIcon(name: string, solid: boolean): IconDefinition | undefined {
  if (solid) {
    return solidIcons[name] ?? regularIcons[name];
  }
  return regularIcons[name];
}
